import { createSelector } from '@reduxjs/toolkit'
import sortBy from 'lodash/sortBy'
import { RootState } from 'lib/core/data/reducer'
import { CountryOption } from './types'

export const getSlice = (state: RootState) => {
  return state.common.countryList
}

export const getCountryList = createSelector(
  getSlice,
  slice => {
    const elements = sortBy(slice.payload, ['full_name_locale'])
    return elements
  }
)

export const getCountryOptions = createSelector(
  getCountryList,
  countries => {
    if (!countries) {
      return []
    }

    const options: CountryOption[] = countries.map(obj => {
      const { id: value, full_name_locale: label } = obj
      return {
        value,
        label
      }
    })

    return options
  }
)
